<div
  [formGroup]="formGroup"
  class="d-flex align-items-center justify-content-between attachment-inline attachment-inline--{{
    !!control?.value ? 'selected' : ''
  }}"
>
  <div class="d-flex align-items-center">
    <checkbox *ngIf="!disabled" [form]="formGroup" [controlName]="attachment?.id.toString()" />

    <div
      *ngIf="!isImage"
      class="d-flex align-items-center pointer attachment-inline__ico__holder"
      docPreview
      [file]="!!attachment && attachment?.isUploaded ? attachment : null"
      (onLoading)="downloading = $event"
      [title]="attachment.name"
    >
      <span class="attachment-inline__title" [title]="attachment?.name">{{ attachment?.name }}</span>
    </div>

    <a
      draggable="false"
      *ngIf="isImage"
      class="d-flex align-items-center pointer attachment-inline__ico__holder"
      [href]="attachment?.file | authFile: null : null : !privateFile"
      [attr.data-fancybox]="fancyboxUrl"
      (click)="openImage($event)"
    >
      <span class="attachment-inline__title" [title]="attachment?.name">{{ attachment?.name }}</span>
    </a>
  </div>

  @if (!attachment?.isUploaded) {
    <div class="attachment-inline__progress">
      <mat-progress-bar mode="determinate" [value]="uploadProgress()" />
    </div>
  }

  <div class="d-flex align-items-center">
    <app-button
      [type]="'button'"
      *ngIf="!!attachment?.isUploaded"
      [loading]="downloading"
      (click)="downloadAttachment()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
        text: 'download' | translate,
        prependSrc: './assets/img/download-blue-icon.svg'
      }"
    />
  </div>
</div>
